var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2003 7.54981C14.2003 8.29539 13.5959 8.89981 12.8503 8.89981C12.1047 8.89981 11.5003 8.29539 11.5003 7.54981V2.14981C11.5003 1.40422 12.1047 0.799805 12.8503 0.799806C13.5959 0.799806 14.2003 1.40422 14.2003 2.14981V7.54981Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6003 7.69981V2.81227C10.6003 2.13048 10.2151 1.5072 9.60526 1.2023L9.5604 1.17987C9.06052 0.929928 8.50932 0.799805 7.95043 0.799805L3.07592 0.799805C2.2179 0.799805 1.47915 1.40543 1.31088 2.2468L0.230879 7.64679C0.00811383 8.76062 0.86004 9.7998 1.99592 9.7998H5.20028V13.3998C5.20028 14.3939 6.00616 15.1998 7.00028 15.1998C7.49733 15.1998 7.90028 14.7969 7.90028 14.2998V13.6998C7.90028 12.9209 8.15292 12.163 8.62028 11.5398L9.88028 9.85981C10.3476 9.23666 10.6003 8.47874 10.6003 7.69981Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.c4c9dc90208bab240ad7df5c6c9ca74c.svg";
export { ForwardRef as ReactComponent };